import React, { useEffect } from "react";
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import Accordion from 'react-bootstrap/Accordion'
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import Table from 'react-bootstrap/Table'
import { GiBulletBill } from 'react-icons/gi'
import { FaBirthdayCake } from 'react-icons/fa'
import { FiSave } from 'react-icons/fi'
import { IoIosAdd, IoIosWarning, IoIosStats } from 'react-icons/io'
import { TiUserDelete } from 'react-icons/ti'
import './index.css'
import '../../main.css'
import { UpdateTeam, GetTeam, GetRidersByEvent, GetLeaguesByIds, GetDisabled, GetResults, GetEvents } from '../../../ApiRampageRequests'
import Helmet from 'react-helmet'
import Flag from 'react-world-flags';
import getCountryISO2 from 'country-iso-3-to-2';
import Tower_Ad_Left from '../../../Images/DMR/Tower_Ad_Left.jpg'
import Tower_Ad_Right from '../../../Images/DMR/Tower_Ad_Right.jpg'


const RampageEditTeam = (props) => {
    const navigate = useNavigate()
    const location = useLocation()
    const [leagueId, setLeagueId] = useState('')
    const [league, setLeague] = useState({})
    const [teamId, setTeamId] = useState('')
    const [riders, setRiders] = useState([])
    const [filteredRiders, setFilteredRiders] = useState(riders)
    const [userTeam, setUserTeam] = useState([])
    const [team, setTeam] = useState([])
    const [maleCount, setMaleCount] = useState(0)
    const [femaleCount, setFemaleCount] = useState(0)
    const [teamValue, setTeamValue] = useState(0)
    const [genderFilter, setGenderFilter] = useState('All')
    const [countryFilter, setCountryFilter] = useState('All')
    const [countries, setCountries] = useState([])

    const [fullTeam, setFullTeam] = useState({})
    const [matchingTeams, setMatchingTeams] = useState([])
    const [showSaveTeam, setShowSaveTeam] = useState(false)
    const [editingDisabled, setEditingDisabled] = useState(false)
    const [showSaveTeamError, setShowSaveTeamError] = useState(false)
    const [errorMessage, setErrorMessage] = useState('There has been an error detected with your team. Please ensure your team has been properly completed. ')
    const [events, setEvents] = useState([])
    const [event, setEvent] = useState({})

    const [pastResultRider, setPastResultRider] = useState({})
    const [showResultsModal, setShowResultsModal] = useState(false)

    const [results, setResults] = useState([])
    const [filteredResults, setFilteredResults] = useState([])
    const [genderResultFilter, setGenderResultFilter] = useState('m')
    const [pointsResultFilter, setPointsResultFilter] = useState('Overall')

    const params = new URLSearchParams(location.search);
    const _leagueId = params.get('leagueId');

    const riderIndex = filteredResults.findIndex(result => result.riderId === pastResultRider._id);

    const RAMPGE_EVENT_ID = "6504b200d4cb5b56c139ca08"


    const getEditingDisabled = async () => {
        const res = await GetDisabled()
        if (!res || !res.data) {
            console.log("NO DATA")
            return
        }

        setEditingDisabled(res.data.disabled)
    }

    //Save the team 
    const saveTeam = async () => {
        const userId = localStorage.getItem('userID')
        const ridersArray = team.map((rider) => ({
            riderId: rider._id,
            position: rider.position,
        }));;
        const data = {
            userId: userId,
            riders: ridersArray,
            leagueId: [leagueId]
        }

        console.log("About to update team with", data)
        const res = await UpdateTeam(data, userId)

        if (res) {
            if (_leagueId == null) {
                navigate(`/rampage/Leagues`)
            } else {
                navigate(`/rampage/League?leagueId=${_leagueId}`)
            }

        } else {
            setShowSaveTeam(false)
            setShowSaveTeamError(true)
        }
    }

    const addToTeam = async (rider) => {
        rider.position = 0;
        if (team.length < 5) {
            setTeam(prevTeam => [...prevTeam, rider])
        }
    }

    //Remove a rider from the team
    const removeFromTeam = (rider) => {
        rider.position = 0;
        const updatedTeam = team.filter(r => r._id !== rider._id);
        setTeam(updatedTeam);
    }

    //Get team from user
    const getTeam = async (id) => {
        const userId = localStorage.getItem("userID")
        const _teamData = await GetTeam(userId)

        if (!_teamData) { return }
        if (!'data' in _teamData) {
            console.log('No data in team')
            return
        }

        setFullTeam(_teamData)
        const _team = _teamData.data
        setUserTeam(_team.riders)
        return _team
    }

    //Gets the list of all riders
    const getRiders = async () => {
        const riders = await GetRidersByEvent(RAMPGE_EVENT_ID)

        if (!riders) { return }
        if (riders.data.length == 0) { return }

        const sorted = [...riders.data].sort((a, b) => a.last_name.localeCompare(b.last_name));
        const _countries = [...new Set(riders.data.map(obj => obj.country))].sort((a, b) => a.localeCompare(b));

        setCountries(_countries)
        setRiders(sorted)
        setFilteredRiders(sorted)

        return sorted
    }

    const getRidersAndTeam = async () => {
        const _riders = await getRiders()

        const _team = await getTeam()

        if (!_team) { return }
        if (!'riders' in _team) { return }

        const _teamRiders = []

        if (!_riders) {
            return
        }
        //Match team rider Id's to riders array
        _team.riders.map((teamRider, index) => {
            const _rider = _riders.find(rider => rider._id == teamRider.riderId)
            _rider.position = teamRider.position
            const isInTeam = team.some((teamRider) => teamRider.riderId === _rider._id);

            if (_rider && !isInTeam) {
                _teamRiders.push(_rider)
            }
        })

        if (_teamRiders.length != 0) {
            setTeam(_teamRiders)
        }
    }

    const sortTeamByPosition = () => {
        const sorted = [...team].sort((a, b) => a.position - b.position);
        setTeam(sorted)
    }

    const handleFilter = (genderValue, countryValue) => {
        setGenderFilter(genderValue)
        setCountryFilter(countryValue)

        if (genderValue === 'All' && countryValue === 'All') {
            const sorted = [...riders].sort((a, b) => a.last_name.localeCompare(b.last_name));
            setFilteredRiders(sorted);
        } else {
            const genderFilter = genderValue === 'Male' ? 'm' : 'f';
            const filtered = riders.filter((rider) => {
                const isGenderMatch = genderValue === 'All' || rider.gender === genderFilter;
                const isCountryMatch = countryValue === 'All' || rider.country === countryValue;
                return isGenderMatch && isCountryMatch;
            });
            const sorted = [...filtered].sort((a, b) => a.last_name.localeCompare(b.last_name));
            setFilteredRiders(sorted);
        }
    }

    const getLeague = async () => {
        const res = await GetLeaguesByIds([_leagueId])

        try {
            if (!res || !res.data) { return }
            if (res.data.length == 0) { return }

            const _league = res.data[0]
            setLeague(_league)

        } catch (error) {
            console.log(error)
        }
    }

    const handlePastResults = (rider) => {
        setPastResultRider(rider)
        setShowResultsModal(true)
    }

    const validatePodium = (riders) => {
        const positions = new Set();

        for (const rider of riders) {
            const position = rider.position;

            // Check if position is not between 1 and 5
            if (position < 1 || position > 5) {
                return {
                    isValid: false,
                    errorMessage: `Invalid position for ${rider.first_name} ${rider.last_name}. Position must be between 1 and 5.`,
                };
            }

            // Check if position has already been selected
            if (positions.has(position)) {
                return {
                    isValid: false,
                    errorMessage: `Duplicate position ${position} selected.`,
                };
            }

            positions.add(position);
        }

        // Check if all positions from 1 to 5 are selected
        if (positions.size !== 5) {
            return {
                isValid: false,
                errorMessage: 'You must select exactly 5 unique positions.',
            };
        }

        // If all checks pass, the podium is valid
        return {
            isValid: true,
        };
    }

    const handleValidateAndSaveTeam = () => {
        const validationResult = validatePodium(team)

        if (validationResult.isValid) {
            sortTeamByPosition()
            setShowSaveTeam(true)
        } else {
            setErrorMessage(validationResult.errorMessage)
            setShowSaveTeamError(true)
        }
    }

    const handlePositionChange = (riderId, newPosition) => {
        const updatedRiders = team.map((rider) =>
            rider._id === riderId ? { ...rider, position: newPosition } : rider
        );
        // updatedRiders.sort((a, b) => a.position - b.position)
        setTeam(updatedRiders);
    };


    useEffect(() => {
        setLeagueId(_leagueId)
        setGenderFilter('All')
        getRidersAndTeam()
        getLeague()
        getEditingDisabled()
    }, []);

    const renderCountriesFilter = (country, index) => {
        return (
            <>
                <Dropdown.Item value={country} onClick={(e) => handleFilter('All', e.target.text)}>{country}</Dropdown.Item>
            </>
        )
    }



    const renderRiders = (rider, index) => {

        const isInTeam = team.some((teamRider) => teamRider._id === rider._id);
        const teamFull = (Array.isArray(team) && team.length == 6)
        const teamLimit = team.length > 4 ? true : false

        let riderDisabled = false
        if (isInTeam || teamFull || teamLimit) {
            riderDisabled = true
        }
        const alpha2Code = getCountryISO2(rider.country);

        return (
            <div >
                <Card className="my-2 border-0 shadow " bg='' >
                    <Card.Body className="p-2">
                        <div className="row px-4">
                            <div className="col-md d-flex flex-row align-items-center justify-content-center justify-content-sm-start my-sm-0 my-2"> <Flag code={alpha2Code} style={{ maxHeight: '1rem' }} className="me-3 mb-2" /> <Card.Title className="fs-6"><span className="fw-light fs-6">{rider?.first_name} </span>{rider?.last_name}<span className="fw-light fs-6 ms-1">({rider?.gender}) </span></Card.Title></div>
                            {/* <div className="col-md fs-6 align-items-center fw-light hidden-mobile">{rider?.country} <Flag code={alpha2Code} style={{maxHeight: '1rem'}} className="ms-2"/></div> */}
                            {/* <div className="col-sm w-100 fs-6 d-flex align-items-center fw-light flex-row justify-content-center">
                                <Button className="w-100 my-sm-0 my-2" variant="outline-warning" onClick={() => { setGenderResultFilter(rider.gender); handlePastResults(rider); handleResultsFilter(rider.gender, pointsResultFilter, event) }}><IoIosStats size={20} className="mb-1 me-2"></IoIosStats>Past Results</Button>
                            </div> */}
                            <div className="col-sm col fs-6 align-items-end-sm justify-content-end align-items-center fw-light mt-sm-0 mt-1 hidden-mobile">
                                <FaBirthdayCake className="me-1 mb-1"></FaBirthdayCake> {rider.DOB}
                            </div>
                            <div className="col-md-4 col-lg-2 fs-6 d-flex align-items-center fw-light d-flex flex-row justify-content-end">
                                {riderDisabled ? <Button className="w-100" disabled variant="outline-secondary" onClick={() => addToTeam(rider)}><IoIosAdd size={20} className="mb-1 me-2"></IoIosAdd>Add Rider</Button> : <Button className="w-100" variant="dark" onClick={() => addToTeam(rider)}><IoIosAdd size={20} className="mb-1 me-2"></IoIosAdd>Add Rider</Button>}
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        )
    }

    const renderTeam = (rider, index) => {
        const alpha2Code = getCountryISO2(rider.country);
        return (
            <div>
                <Card className="my-2 border-0 shadow" style={{ backgroundColor: 'rgb(244, 235, 229)' }}>
                    <Card.Body className="p-2">
                        <div className="row px-4">
                            <div className="col-lg-1 col-md-2 my-2 my-lg-0">
                                <Form.Control className="col-sm-1" type="number" min="1" max="5" placeholder="position" defaultValue={0} value={rider.position} onChange={(e) => handlePositionChange(rider._id, parseInt(e.target.value))} />
                            </div>
                            <div className="col-md d-flex flex-row align-items-center justify-content-center justify-content-sm-start my-sm-0 my-2">  <Flag code={alpha2Code} style={{ maxHeight: '1rem' }} className="me-3 mb-2" /> <Card.Title className="fs-6"><span className="fw-light fs-6">{rider.first_name} </span>{rider.last_name}</Card.Title></div>
                            {/* <div className="col-md fs-6 align-items-center fw-light hidden-mobile">{rider.country} <Flag code={alpha2Code} style={{maxHeight: '1rem'}} className="ms-2"/></div> */}
                            <div className="col-sm col fs-6 align-items-end-sm justify-content-end align-items-center fw-light mt-sm-0 mt-1 hidden-mobile">
                                <FaBirthdayCake className="me-1 mb-1"></FaBirthdayCake> {rider.DOB}
                            </div>
                            <div className="col-md-4 col-lg-2 fs-6 d-flex align-items-center fw-light d-flex flex-row justify-content-end">
                                <Button className="w-100" variant="outline-dark" onClick={() => removeFromTeam(rider)}><TiUserDelete size={20} className="mb-1 me-2"></TiUserDelete>Remove</Button>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        )
    }

    const confirmTeam = (rider, index) => {
        const alpha2Code = getCountryISO2(rider.country);
        return (
            <div>
                <Card className="my-2 border-0 shadow" style={{ backgroundColor: 'rgb(244, 235, 229)' }}>
                    <Card.Body className="p-2">
                        <div className="row px-4">
                            <div className="col-lg-1 col-2 d-flex flex-row align-items-center my-sm-0 my-2">{rider.position}</div>
                            <div className="col-sm col-10 flex-row align-items-center my-sm-0 my-2">
                                <Card.Title className="fs-6 my-0">
                                    <div className="d-flex flex-row">
                                        <Flag code={alpha2Code} style={{ maxHeight: '1rem' }} className="me-3 mb-0" />
                                        <span className="fw-light fs-6">{rider.first_name} </span>{rider.last_name}
                                    </div>
                                </Card.Title>
                            </div>
                            {/* <div className="col-sm fs-6 align-items-start-sm align-items-center fw-light hidden-mobile">{rider.country}</div> */}
                        </div>
                    </Card.Body>
                </Card>
            </div>
        )
    }


    const renderResult = (result, index, type) => {
        let points = 0;
        switch (type) {
            case 'Overall':
                points = result.total_points;
                break;
            case 'Qualifying':
                points = result.qualifying_points;
                break;
            case 'Semis':
                points = result.semis_points;
                break;
            case 'Finals':
                points = result.finals_points;
                break;
            default:
                points = 0;
        }


        return (
            <>
                {
                    result.riderId == pastResultRider._id &&
                    result.eventId == event._id &&
                    <tr key={index}>
                        <td style={{ fontSize: '14px' }}>{points == 0 ? '-' : index}</td>
                        <td style={{ fontSize: '14px' }}>{result.rider_first_name} <b>{result.rider_last_name}</b></td>
                        {type == 'Overall' && <td className="d-flex justify-content-between" style={{ fontSize: '14px' }}>{result.total_points}</td>}
                        {type == 'Qualifying' && <td className="d-flex justify-content-between" style={{ fontSize: '14px' }}>{result.qualifying_points}</td>}
                        {type == 'Semis' && <td className="d-flex justify-content-between" style={{ fontSize: '14px' }}>{result.semis_points}</td>}
                        {type == 'Finals' && <td className="d-flex justify-content-between" style={{ fontSize: '14px' }}>{result.finals_points}</td>}
                    </tr>
                }
            </>
        )
    }


    return (
        <div className="container pt-3 rampage-container-background " >
            <Helmet>
                <title>Edit Team - 2023 Rampage Fantasy</title>
                <meta name="description" content="Edit your existing fantasy team for the downhill mountain biking league. Make changes to your rider selections and optimize your team's performance." />
            </Helmet>
            <div className="left-ad">
                <a href="https://www.dmrbikes.com">
                    <img src={Tower_Ad_Left} className='left-ad' alt="Left Ad" />
                </a>
            </div>
            <div className="px-3 pb-1 transition">
                <div className=" mt-2 d-flex flex-row justify-content-sm-center fw-bold fs-4 ">{league?.name}</div>
                <div className="mb-2 d-flex flex-row justify-content-sm-center fw-light fs-6 ">{league?.description}</div>
                <div className="my-3"> <span className="fw-bold">Rules: </span>
                    <div className="ms-3 fw-light"><GiBulletBill></GiBulletBill> You may edit your team as many times as you would like.</div>
                    <div className="ms-3 fw-light"><GiBulletBill></GiBulletBill> Team editing is locked when the event begins.</div>
                    <div className="ms-3 fw-light"><GiBulletBill></GiBulletBill> Select 5 riders. Guess what position 1-5 you think they'll finish</div>
                    <div className="ms-3 fw-light"><GiBulletBill></GiBulletBill> +100 points for every selected rider in the top 5.</div>
                    <div className="ms-3 fw-light"><GiBulletBill></GiBulletBill> +100 points for every rider & rank guessed correctly.</div>
                </div>
                <Accordion defaultActiveKey={'0'} alwaysOpen className="border-0 shadow">
                    <Accordion.Item eventKey="0" className="border-0">
                        <Accordion.Header className="accordion-rampage">
                            <div className="row w-100">
                                <div className="col-sm-6">
                                    {Array.isArray(team) ?
                                        <div className="h4">Selected {team.length} of 5 riders</div> : <div className="h4">Select 5 riders</div>
                                    }
                                </div>
                                <div className="col-sm-6 d-flex flex-row justify-content-end pe-5">
                                    <div className="h4">Remaining: {(5 - team.length).toLocaleString()}</div>
                                </div>
                            </div>

                        </Accordion.Header>
                        <Accordion.Body variant='warning'>
                            <div className="">
                                {Array.isArray(team) && team.map(renderTeam)}
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
                <div className="d-flex flex-row justify-content-end pt-3">
                    <Button variant='warning' disabled={editingDisabled || (Array.isArray(team) && team.length != 5)} onClick={() => handleValidateAndSaveTeam()}><FiSave size={20} className="mb-1 me-2"></FiSave>Save Team</Button>
                </div>
            </div>
            <hr></hr>
            <div className="px-3 py-2 transition">
                <div className="row mb-3">
                    <div className="col-lg-1 h4 me-lg-4">Riders</div>
                    <div className="col-lg-1 d-flex align-items-center fw-light justify-content-lg-end">Country:</div>
                    <div className="col-lg d-flex flex-row justify-content-start">
                        <DropdownButton onChange={(e) => console.log(e.target.value)} id="dropdown-basic-button" variant='outline-secondary' title={countryFilter} className="">
                            <Dropdown.Item value='All' onClick={(e) => handleFilter('All', 'All')}>All</Dropdown.Item>
                            {Array.isArray(countries) && countries.map(renderCountriesFilter)}
                        </DropdownButton>
                    </div>
                </div>
                {Array.isArray(filteredRiders) && filteredRiders.map(renderRiders)}
            </div>


            <Modal size='lg' show={showSaveTeam} onHide={() => setShowSaveTeam(false)}>
                <Modal.Header closeButton>
                    <FiSave size={24} className="me-2"></FiSave>
                    <Modal.Title>Save Team</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Label className="fw-light">Would you like to apply these changes to your team? </Form.Label>
                    {(Array.isArray(team)) && team.map(confirmTeam)}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className="px-4" onClick={() => setShowSaveTeam(false)}>
                        Close
                    </Button>
                    <Button variant="warning" className="px-4" onClick={() => saveTeam()}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal size='md' show={showSaveTeamError} onHide={() => setShowSaveTeamError(false)}>
                <Modal.Header closeButton>
                    <IoIosWarning size={24} className="me-2"></IoIosWarning>
                    <Modal.Title>Could not save team. </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Label className="fw-light">{errorMessage}</Form.Label>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className="px-4" onClick={() => setShowSaveTeamError(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            <div className="right-ad">
                <a href="https://www.dmrbikes.com">
                    <img src={Tower_Ad_Right} className="right-ad" alt="Right Ad" />
                </a>
            </div>
        </div>
    );
}

export default RampageEditTeam;